import React from 'react'
import MediaQuery from 'react-responsive'
import { Input, Button } from 'semantic-ui-react'
import Mensagens from '../../../Mensagens';


class PesquisaNomeEvento extends React.Component {
    usernameField = null
    render() {
        return <div>
            <Input
                fluid
                placeholder={Mensagens.p14}
                icon='search'
                ref={(c) => this.usernameField = c}
                onChange={(e, i) => this.onChange(e.target.value, false)} />

            <MediaQuery maxWidth={400}>
                <Button className='button type2' type='button' onClick={(e, i) => this.onChange(e.target.value, true)} secondary>Pesquisar</Button>
            </MediaQuery>
        </div>
    }

    onChange = (value, i) => {
        if (this.props.onSearch)
            this.props.onSearch(value, i)
    }
}

export default PesquisaNomeEvento


// WEBPACK FOOTER //
// ./src/components/Eventos/Pesquisa/PesquisaNomeEvento.js